
angular.module('gallery').factory('Ads', ['$rootScope', function ($rootScope) {
    var counter = 0;
    var minDesctopWidth = 992;

    $rootScope.$on('updateMetaInfo', function () {
        if (!isDesktop()) {
            return;
        }
        updateCounter();
        refreshAds();
    });

    function updateCounter () {
        counter ++;
    }

    function refreshAds () {
        /*
         * on every view of image slide, the counter will be updated by 1
         * after 3 images scrolled pass, we will refresh the right rail ad
         */
        if (counter < 3) {
            return;
        }

        var slotId = getSlotId();
        FsAds.refresh([slotId]);
        //reset counter to 0 after ad is refreshed every 3 slide images
        counter = 0;
    }

    function getSlotId(){

        var currentStory = getCurrentStory();

        var adContainerEl = document.querySelector('#story-' + currentStory + ' .right-rail > .fsAdContainer');

        return adContainerEl.id;

    }

    /**
     * @desc Get current story ID. On gallery page load, the story ID is 1.
     * Any gallery page that is loaded after the first story, the story ID is set on onPageChanged method
     * in threethings/factories/storyEvents.service.js
     * @returns {Number}
     */
    function getCurrentStory(){
        if (typeof FsCurrentStory !== 'undefined'){
            return FsCurrentStory;
        }else{
            return 1;
        }
    }

    function isDesktop () {
        if (minDesctopWidth <= window.innerWidth) {
            return true;
        }
        return false;
    }

    return {};
}]);



// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/ads/adsService.js